import { defineSlotRecipe } from '@chakra-ui/react'

export const imageCard = defineSlotRecipe({
  className: 'ImageCard',
  slots: ['figure', 'caption', 'figcaption', 'heading', 'subHeading', 'link'],
  base: {
    figure: {
      borderRadius: 'sm',
      overflow: 'hidden',
      backgroundColor: 'brand.white',
      boxShadow: 'brand.boxShadow',
    },
    figcaption: {
      paddingX: 4,
    },
    heading: {
      fontSize: 'xl',
      fontWeight: 'light',
      lineHeight: 'taller',
      marginTop: 4,
      marginBottom: 1,
    },
    caption: {
      fontSize: 'md',
      fontWeight: 'normal',
      lineHeight: 'base',
      marginTop: '4',
    },
  },
})
